// 自定义指令
import * as directive from '@/directive'
import '@/permission'
// 自定义样式
import '@/styles/index.scss'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import { createPinia } from 'pinia'
import { createApp, Directive } from 'vue'
import App from './App.vue'
import router from './router/index'
import Plugins from '@/plugins'
const app = createApp(App)

// 全局错误类型
app.config.errorHandler = (err, vm, info) => {
  window.console.log('[全局异常]', err, vm, info)
}

Object.keys(directive).forEach((key) => {
  app.directive(key, (directive as { [key: string]: Directive })[key])
})

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia() as any)
app.use(router as any)
app.use(Plugins)
app.mount('#app')
